
export default function AboutSection() {
  const features = [
    {
      icon: 'ri-speed-line',
      title: 'Velocidade Garantida',
      description: 'Internet com velocidade real, sem oscilações ou quedas de conexão.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Conexão Estável',
      description: 'Tecnologia 100% fibra óptica para máxima estabilidade e confiabilidade.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Suporte 24/7',
      description: 'Atendimento especializado disponível todos os dias, 24 horas por dia.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Instalação Gratuita',
      description: 'Nossa equipe técnica realiza a instalação sem custo adicional.'
    }
  ];

  return (
    <section id="sobre" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Por que escolher a <span className="text-orange-600">Legacy Telecom</span>?
            </h2>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              Somos especialistas em internet fibra óptica, oferecendo a melhor experiência 
              de conectividade para residências e empresas. Nossa missão é levar internet 
              de alta qualidade com preços justos e atendimento excepcional.
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start">
                  <div className="w-12 h-12 bg-gradient-to-r from-orange-500 to-purple-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className={`${feature.icon} text-white text-xl`}></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">{feature.title}</h3>
                    <p className="text-gray-600 text-sm">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="relative">
            <img 
              src="https://readdy.ai/api/search-image?query=Professional%20telecommunications%20technician%20installing%20fiber%20optic%20internet%20equipment%2C%20modern%20network%20infrastructure%20setup%2C%20orange%20and%20purple%20lighting%2C%20high-tech%20fiber%20optic%20cables%20and%20routers%2C%20clean%20professional%20workspace%2C%20technology%20installation%20process%2C%20expert%20technical%20service%2C%20modern%20internet%20connectivity%20equipment&width=600&height=800&seq=about-image&orientation=portrait"
              alt="Técnico Legacy Telecom"
              className="rounded-2xl shadow-2xl w-full h-auto object-cover"
            />
            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl p-6 shadow-xl">
              <div className="text-3xl font-bold text-orange-600 mb-1">5+</div>
              <div className="text-sm text-gray-600">Anos de experiência</div>
            </div>
            <div className="absolute -top-6 -right-6 bg-white rounded-xl p-6 shadow-xl">
              <div className="text-3xl font-bold text-purple-600 mb-1">1000+</div>
              <div className="text-sm text-gray-600">Clientes satisfeitos</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
